import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface BreadcrumbItem {
  label: string;
  url?: string;
  icon?: string;
}

@Component({
  selector: 'abp-breadcrumb',
  standalone: true,
  imports: [RouterModule, CommonModule],
  template: `
    @if (items.length > 0)
    {
      <div class="breadcrumb-wrapper">
        <div class="breadcrumb-container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a routerLink="/dashboard">
                  <i class="fas fa-home"></i>
                  Ana Sayfa
                </a>
              </li>
              <li
                class="breadcrumb-item"
                *ngFor="let item of items; let last = last"
                [class.active]="last"
              >
                @if (item.icon)
                {
                  <i [class]="item.icon"></i>
                }

                @if (!last && item.url)
                {
                  <a [routerLink]="item.url">{{ item.label }}</a>
                }

                @if (last || !item.url)
                {
                  <span>{{ item.label }}</span>
                }
              </li>
            </ol>
          </nav>
        </div>
      </div>
    }
  `,
  styles: [`
    .breadcrumb-wrapper {
      background: white;
      border-bottom: 1px solid #E2E8F0;
      margin-bottom: 1.5rem;
    }

    .breadcrumb-container {
      padding: 1rem 0;
    }

    .breadcrumb {
      margin: 0;
      padding: 0;
      background: transparent;
      display: flex;
      flex-wrap: wrap;
      list-style: none;
    }

    .breadcrumb-item {
      font-size: 0.875rem;
      color: #475569;

      a {
        color: #475569;
        text-decoration: none;
        transition: color 0.3s;

        &:hover {
          color: #6366F1;
        }
      }

      &.active {
        color: #0F172A;
        font-weight: 500;
      }

      + .breadcrumb-item::before {
        content: "/";
        color: #94A3B8;
        padding: 0 0.5rem;
      }

      i {
        margin-right: 0.25rem;
      }
    }
  `]
})
export class BreadcrumbComponent {
  @Input() items: BreadcrumbItem[] = [];

  constructor(private router: Router) {
    // Router değişikliklerini dinle
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.updateBreadcrumb(event.url);
      });

    // İlk yükleme için mevcut URL'i kontrol et
    this.updateBreadcrumb(this.router.url);
  }

  private updateBreadcrumb(url: string) {
    // URL'e göre breadcrumb öğelerini ayarla
    const urlSegments = url.split('/').filter(segment => segment);

    if (urlSegments.length === 0 || urlSegments[0] === 'dashboard') {
      this.items = [];
    } else {
      // Route'a göre label belirle
      const routeLabels: { [key: string]: string } = {
        'students': 'Öğrencilerim',
        'calendar': 'Takvim & Görevler',
        'reports': 'Raporlar',
        'identity': 'Kimlik Yönetimi',
        'users': 'Kullanıcılar',
        'roles': 'Roller',
        'setting-management': 'Ayarlar'
      };

      this.items = urlSegments.map((segment, index) => {
        const label = routeLabels[segment] || segment;
        const url = '/' + urlSegments.slice(0, index + 1).join('/');

        return {
          label: label,
          url: index < urlSegments.length - 1 ? url : undefined
        };
      });
    }
  }
}
